import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import {
  Calculator,
  Users,
  ArrowRight,
  Building2,
} from 'lucide-react';

const SystemSelector = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  // Si el usuario solo tiene acceso a un sistema, redirigir automáticamente
  React.useEffect(() => {
    if (user.has_accounting_access && !user.has_hr_access) {
      navigate('/dashboard');
    } else if (!user.has_accounting_access && user.has_hr_access) {
      navigate('/rrhh/catalogo/general');
    }
  }, [user, navigate]);

  // Si el usuario tiene acceso a ambos sistemas, mostrar el selector
  if (!user.has_accounting_access && !user.has_hr_access) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardContent className="p-8 text-center">
            <p className="text-slate-600">No tienes permisos para acceder a ningún sistema.</p>
            <Button 
              variant="outline" 
              className="mt-4"
              onClick={() => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/';
              }}
            >
              Cerrar Sesión
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-purple-900 flex items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Building2 className="h-12 w-12 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Express Products</h1>
          <p className="text-slate-400">
            Bienvenido, <span className="text-white font-medium">{user.full_name || 'Usuario'}</span>
          </p>
          <p className="text-slate-500 text-sm mt-1">Selecciona el sistema al que deseas acceder</p>
        </div>

        {/* System Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Sistema Contable */}
          {user.has_accounting_access && (
            <Card 
              className="group cursor-pointer hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-blue-500 bg-white/10 backdrop-blur"
              onClick={() => navigate('/dashboard')}
            >
              <CardContent className="p-8">
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                    <Calculator className="h-10 w-10 text-white" />
                  </div>
                  <h2 className="text-2xl font-bold text-white mb-2">Sistema Contable</h2>
                  <p className="text-slate-400 mb-6">
                    Gestión de transacciones, reportes financieros, bancos, activos y más.
                  </p>
                  <Button className="bg-blue-600 hover:bg-blue-700 text-white group-hover:gap-3 transition-all">
                    Acceder
                    <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          )}

          {/* Sistema RRHH */}
          {user.has_hr_access && (
            <Card 
              className="group cursor-pointer hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-purple-500 bg-white/10 backdrop-blur"
              onClick={() => navigate('/rrhh/catalogo/general')}
            >
              <CardContent className="p-8">
                <div className="flex flex-col items-center text-center">
                  <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                    <Users className="h-10 w-10 text-white" />
                  </div>
                  <h2 className="text-2xl font-bold text-white mb-2">Sistema RRHH</h2>
                  <p className="text-slate-400 mb-6">
                    Gestión de empleados, planilla, contratos, ausencias y más.
                  </p>
                  <Button className="bg-purple-600 hover:bg-purple-700 text-white group-hover:gap-3 transition-all">
                    Acceder
                    <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        {/* Footer */}
        <div className="text-center mt-10">
          <Button 
            variant="ghost" 
            className="text-slate-400 hover:text-white"
            onClick={() => {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              window.location.href = '/';
            }}
          >
            Cerrar Sesión
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SystemSelector;
